import { ChangeDetectionStrategy, Component, SkipSelf } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonInputComponent } from '../../../../../../../../../../ui/form-components/radio-button-input/radio-button-input.component';

@Component({
  selector: 'app-vb-written-cheque-card',
  templateUrl: './vb-written-cheque-card.component.html',
  styleUrls: ['./vb-written-cheque-card.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RadioButtonInputComponent],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]]
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbWrittenChequeCardComponent {}
